module.exports = __webpack_public_path__ + "img/subevent-icon.908332ca.svg";